var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8505 12.2454C14.7593 13.1544 15.8018 13.2982 16.4793 12.6209L20.8946 8.20607C21.7711 7.33009 21.7711 5.89654 20.8946 5.02056L18.4479 2.57398C17.5718 1.698 16.138 1.698 15.2614 2.57398L10.8462 6.98879C10.1578 7.67665 10.3223 8.71784 11.2217 9.6171",
    stroke: "#126DFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34397 11.4943C8.45281 10.6033 7.41105 10.423 6.71517 11.1188L2.30631 15.4908C1.42641 16.3638 1.42341 17.7943 2.29955 18.6703L4.7954 21.1657C5.67154 22.0417 7.10236 22.0383 7.97512 21.1589L12.3483 16.7509C13.0363 16.0626 12.8726 15.0222 11.9728 14.1226",
    stroke: "#126DFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8418 15.6247L15.3526 8.11523",
    stroke: "#126DFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferal);
export default __webpack_public_path__ + "static/media/referal.38a4c326.svg";
export { ForwardRef as ReactComponent };